<img
  *ngIf="image && !isImageError; else noImage"
  (error)="onImageLoadError()"
  [src]="image | imageUrl | resizeImg : size * 1.5"
/>
<ng-template #noImage>
  <span *ngIf="symbol">{{ symbol }}</span>
</ng-template>
<ng-content></ng-content>
